import { Navigate, Outlet } from "react-router-dom"
const RequireAuth = () => {
    const local_token = localStorage.getItem("accessTR")    
    return (
        local_token
            ? <Outlet/>
            : <Navigate to="/Login" replace />
    )
}


export default RequireAuth